import { forwardRef, HTMLAttributes } from 'react';
import type { SxProps } from '@mui/material';

import { Label, Sup } from './ControlLabel.style';

type ControlLabelProps = {
  sx?: SxProps;
  children: string;
  required?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

const ControlLabel = forwardRef<HTMLSpanElement, ControlLabelProps>(
  ({ children, sx, required = false, ...rest }, ref) => (
    <Label {...rest} ref={ref} sx={sx}>
      {children} {required && <Sup>*</Sup>}
    </Label>
  )
);

export default ControlLabel;
